import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
import { useSiteLayout } from '../../contexts/SiteContext';

const CONTENT_WIDTH: Record<string, string> = {
  narrow: 'max-w-2xl',
  normal: 'max-w-5xl',
  wide: 'max-w-7xl',
  full: 'max-w-none',
};

interface SiteLayoutProps {
  children: React.ReactNode;
  /** When true, content fills the full width (no inner padding/max-w). Useful for Hero blocks. */
  fullBleed?: boolean;
}

export function SiteLayout({ children, fullBleed = false }: SiteLayoutProps) {
  const layout = useSiteLayout();
  const widthClass = CONTENT_WIDTH[layout.contentWidth ?? 'normal'] ?? 'max-w-5xl';

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: 'var(--color-bg, #fafafa)' }}
    >
      <SiteHeader />

      <main className="flex-1">
        {fullBleed ? (
          children
        ) : (
          <div className={`${widthClass} mx-auto w-full px-4 sm:px-6 py-8`}>
            {children}
          </div>
        )}
      </main>

      <SiteFooter />
    </div>
  );
}

/**
 * Minimal layout for auth pages — no nav, no footer.
 */
export function AuthSiteLayout({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: 'var(--color-bg, #fafafa)' }}
    >
      {children}
    </div>
  );
}
